
<div class="modal-header">An error occured</div>
<div class="modal-body">
  <label translate>Error report</label>
  <textarea class="form-control text-monospace" readonly [value]="report" style="min-height: 300px"></textarea>
</div>
<div class="modal-footer">
  <button class="btn btn-info" [copyToClipboardButton]="report"><i class="far fa-fw fa-copy"></i><span translate>Copy all</span></button>
  <button class="btn btn-outline-secondary" (click)="modalInstance.dismiss()"><span translate>Close</span></button>
</div>